// TurnoModal.jsx
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Swal, { avisoExito, avisoFalta, avisoError } from '../../utils/swal';
import baseURL from '../url';
import "./TurnoModal.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment, faUser, faCalendarAlt, faTimesCircle, faClock, faListAlt } from '@fortawesome/free-regular-svg-icons';
import { faPlusCircle, faRedo, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { apiRaw } from '../../api';
import { escapeHtml } from '../../utils/html';
// Importar el ícono de historial de react-icons
import { AiOutlineHistory } from 'react-icons/ai';
import { FaUser, FaPhone, FaBuilding, FaBook, FaUserMd, FaDoorOpen, FaInfoCircle, FaEdit, FaSave, FaClock, FaComment, FaCalendarAlt, FaTools, FaFileExcel as FaFileExcelIcon } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ImportarPacientesTaller from './ImportarPacientesTaller/ImportarPacientesTaller';
// Configurar moment.js para usar el idioma español
moment.locale('es'); // Establecer el idioma a español

const TAB_LIST = [
  { key: 'perfil', label: 'Taller', icon: FaTools, type: 'react' },
  { key: 'citas', label: 'Citas', icon: faCalendarAlt, type: 'fa' },
  { key: 'historial', label: 'Historial', icon: AiOutlineHistory, type: 'react' },
  //{ key: 'comentarios', label: 'Comentarios', icon: faComment, type: 'fa' },
  { key: 'pacientes', label: 'Pacientes', icon: faUser, type: 'fa' },

];

const TurnoModal = ({
  isOpen,
  onClose,
  turnoSeleccionado,
  cargarTurnos,
  nombre,
  setNombre,
  telefono,
  setTelefono,
  motivoInactivo,
  setMotivoInactivo,
  nuevaFecha,
  setNuevaFecha,
  periodicidad,
  setPeriodicidad,
  nuevaHoraInicio,
  setNuevaHoraInicio,
  nuevaHoraFin,
  setNuevaHoraFin,
  nuevoComentario,
  setNuevoComentario,
  comentarioActualizado,
  cancelarActualizado,
  nuevoEstado,
  setNuevoEstado,
  categorias,
  categoriaSeleccionada,
  setCategoriaSeleccionada,
  servicioSeleccionado,
  setServicioSeleccionado,
  terapeutaSeleccionado,
  setTerapeutaSeleccionado,
  salaSeleccionada,
  setSalaSeleccionada,
  citasSeleccionadas,
  setCitasSeleccionadas,
  alertAsignarSala,
  handleUpdateText,
  handleUpdateDate,
  handleInsertComment,
  handleNewAppointment,
  handleCancelar
}) => {

  const [salas, setSalas] = useState([]);
  const [salasDisponibles, setSalasDisponibles] = useState([]);
  const [listaTerapeutas, setListaTerapeutas] = useState([]);
  const [servicios, setServicios] = useState([]);
  const [catalogoMotivosInactivo, setCatalogoMotivosInactivo] = useState([]);
  const [comentarios, setComentarios] = useState([]);
  const [citasProgramadas, setCitasProgramadas] = useState([]);
  const [citasHistorial, setCitasHistorial] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [allPacientes, setAllPacientes] = useState([]);
  const [modalSeleccionarPacienteIsOpen, setModalSeleccionarPacienteIsOpen] = useState(false);
  const [pacienteSeleccionado, setPacienteSeleccionado] = useState('');
  const [buscadorPaciente, setBuscadorPaciente] = useState('');
  const [excelFile, setExcelFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [pacientesLoading, setPacientesLoading] = useState(true);
  const [importModalOpen, setImportModalOpen] = useState(false);
  const [importStep, setImportStep] = useState(1);
  const [importData, setImportData] = useState([]);
  const [importSelected, setImportSelected] = useState([]);
  const [importAllSelected, setImportAllSelected] = useState(false);
  const [importErrors, setImportErrors] = useState({});
  const [importFileName, setImportFileName] = useState('');

  // Estados para edición de sesiones del taller
  const [sesionEditando, setSesionEditando] = useState(null); // { idSesion, fecha, horaInicio, horaFin }
  const [sesionEditandoValores, setSesionEditandoValores] = useState({ fecha: '', horaInicio: '', horaFin: '' });

  // Disponibilidad
  const cupoMaximo = turnoSeleccionado?.cupoMax ?? turnoSeleccionado?.cupo_max ?? turnoSeleccionado?.cupo ?? turnoSeleccionado?.capacidad ?? null;
  const inscritosCount = pacientes?.length || 0;
  const cupoDisponible = cupoMaximo ? Math.max(cupoMaximo - inscritosCount, 0) : null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setExcelFile(file);
      setImportFileName(file.name);
      handleExcelUpload(file);
      // Limpiar el valor del input para permitir seleccionar el mismo archivo de nuevo
      e.target.value = null;
    }
  };

  const openImportModal = () => {
    setImportModalOpen(true);
    setImportStep(1);
    setImportData([]);
    setImportSelected([]);
    setImportAllSelected(false);
    setImportErrors({});
    setImportFileName('');
    setExcelFile(null);
  };

  const closeImportModal = () => {
    setImportModalOpen(false);
    setImportStep(1);
    setImportData([]);
    setImportSelected([]);
    setImportAllSelected(false);
    setImportErrors({});
    setImportFileName('');
    setExcelFile(null);
    setIsUploading(false);
  };

  const handleImportResetFile = () => {
    setImportStep(1);
    setImportData([]);
    setImportSelected([]);
    setImportAllSelected(false);
    setImportErrors({});
    setImportFileName('');
    setExcelFile(null);
  };

  const normalizeSexo = (value) => {
    if (!value) return '';
    return value.toString().trim().toLowerCase().replace(/\s+/g, ' ');
  };

  const validatePacienteRow = (paciente) => {
    const errors = {};
    const nombre = paciente.nombre ? paciente.nombre.toString().trim() : '';
    const telefono = paciente.telefono ? paciente.telefono.toString().trim() : '';
    const sexo = normalizeSexo(paciente.sexo);
    const edad = paciente.edad ? paciente.edad.toString().trim() : '';

    if (!nombre || nombre.length < 3) {
      errors.nombre = 'Nombre requerido (min. 3)';
    }
    if (!telefono) {
      errors.telefono = 'Telefono requerido';
    }
    if (!sexo) {
      errors.sexo = 'Sexo requerido';
    } else if (!['hombre', 'mujer', 'no binario'].includes(sexo)) {
      errors.sexo = 'Use: Hombre, Mujer o No binario';
    }
    if (!edad) {
      errors.edad = 'Edad requerida';
    } else if (Number.isNaN(Number(edad))) {
      errors.edad = 'Edad debe ser numero';
    }

    return errors;
  };

  const handleImportInputChange = (rowIndex, field, value) => {
    setImportData((prev) => {
      const updated = prev.map((item, idx) => {
        if (idx !== rowIndex) return item;
        return { ...item, [field]: value };
      });

      const updatedRow = updated[rowIndex];
      setImportErrors((prevErrors) => {
        const next = { ...prevErrors };
        const rowErrors = validatePacienteRow(updatedRow);
        if (Object.keys(rowErrors).length > 0) {
          next[rowIndex] = rowErrors;
        } else {
          delete next[rowIndex];
        }
        return next;
      });

      return updated;
    });
  };

  const toggleImportSelected = (index) => {
    setImportSelected((prev) => {
      if (prev.includes(index)) {
        const next = prev.filter((i) => i !== index);
        setImportAllSelected(next.length === importData.length && importData.length > 0);
        return next;
      }
      const next = [...prev, index];
      setImportAllSelected(next.length === importData.length && importData.length > 0);
      return next;
    });
  };

  const toggleImportAll = (checked) => {
    if (checked) {
      setImportSelected(importData.map((_, idx) => idx));
      setImportAllSelected(true);
    } else {
      setImportSelected([]);
      setImportAllSelected(false);
    }
  };

  const handleImportSelected = () => {
    if (importSelected.length === 0) {
      avisoFalta('Selecciona al menos un registro para importar.');
      return;
    }

    const nextErrors = {};
    importSelected.forEach((idx) => {
      const rowErrors = validatePacienteRow(importData[idx]);
      if (Object.keys(rowErrors).length > 0) {
        nextErrors[idx] = rowErrors;
      }
    });

    setImportErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) {
      Swal.fire('Error', 'Corrige los errores antes de importar.', 'error');
      return;
    }

    const normalized = importSelected.map((idx) => {
      const row = importData[idx];
      return {
        nombre: row.nombre ? row.nombre.toString().trim() : '',
        telefono: row.telefono ? row.telefono.toString().trim() : '',
        sexo: normalizeSexo(row.sexo),
        edad: row.edad ? row.edad.toString().trim() : ''
      };
    });

    processExcelData(normalized);
  };

  const handleExcelUpload = (file) => {
    if (!file) {
      Swal.fire('Error', 'No se ha seleccionado ningún archivo', 'error');
      return;
    }

    // Verificar la extensión del archivo
    const fileExt = file.name.split('.').pop().toLowerCase();
    if (!['xls', 'xlsx', 'csv'].includes(fileExt)) {
      Swal.fire('Error', 'Formato de archivo no válido. Sube un Excel (.xls o .xlsx) o un CSV (.csv)', 'error');
      return;
    }

    const processWorkbook = (workbook) => {
      console.log('Hojas en el archivo:', workbook.SheetNames);
      
      if (workbook.SheetNames.length === 0) {
        throw new Error('El archivo no contiene hojas');
      }
      
      const firstSheetName = workbook.SheetNames[0];
      console.log('Usando hoja:', firstSheetName);
      
      const worksheet = workbook.Sheets[firstSheetName];
      
      // Leer como JSON con encabezados en la primera fila
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      if (jsonData.length <= 1) { // 1 fila de encabezados + al menos 1 fila de datos
        throw new Error('El archivo está vacío o solo contiene encabezados');
      }
      
      // Obtener los encabezados (primera fila) y normalizarlos (sin tildes y en minúsculas)
      const normalizeText = (text) => {
        return text.toString().trim().toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Eliminar tildes
      };

      const headers = jsonData[0].map(h => h ? normalizeText(h) : '');
      console.log('Encabezados encontrados:', headers);
      
      // Verificar que existan las columnas mínimas requeridas
      const requiredColumns = ['nombre', 'telefono', 'sexo', 'edad'];
      const headerMap = {}; // Mapa para rastrear los nombres de columnas originales
      
      // Crear un mapeo de columnas normalizadas a originales
      jsonData[0].forEach((original, index) => {
        if (original) {
          const normalized = normalizeText(original);
          headerMap[normalized] = original;
        }
      });

      // Verificar columnas faltantes
      const missingColumns = [];
      requiredColumns.forEach(col => {
        if (!headers.includes(col)) {
          missingColumns.push(col);
        }
      });
      
      if (missingColumns.length > 0) {
        throw new Error(`Faltan columnas requeridas: ${missingColumns.join(', ')}`);
      }
      
      // Convertir a array de objetos con los nombres de las columnas normalizados
      const formattedData = [];
      
      // Empezar desde 1 para saltar la fila de encabezados
      for (let i = 1; i < jsonData.length; i++) {
        const row = jsonData[i];
        const item = {};
        
        const hasValues = row.some((cell) => cell !== undefined && cell !== null && cell.toString().trim() !== '');

        // Usar los nombres de columna normalizados para el objeto final
        requiredColumns.forEach(col => {
          const colIndex = headers.indexOf(col);
          if (colIndex !== -1 && row[colIndex] !== undefined) {
            item[col] = row[colIndex] !== null ? row[colIndex].toString().trim() : '';
          } else {
            item[col] = ''; // Valor por defecto si la columna no existe
          }
        });

        if (hasValues) {
          formattedData.push(item);
        }
      }
      
      console.log('Datos procesados:', formattedData);
      
      if (formattedData.length === 0) {
        throw new Error('No se encontraron registros válidos en el archivo');
      }
      
      setImportData(formattedData);
      setImportSelected(formattedData.map((_, idx) => idx));
      setImportAllSelected(formattedData.length > 0);
      setImportErrors({});
      setImportStep(2);
      setIsUploading(false);
    };

    setIsUploading(true);

    // Lectura de CSV
    if (fileExt === 'csv') {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          console.log('Iniciando lectura del archivo CSV...');
          const text = e.target.result;
          const workbook = XLSX.read(text, { type: 'string', codepage: 65001, FS: ',', RS: '\n' });
          processWorkbook(workbook);
        } catch (error) {
          console.error('Error al procesar el archivo CSV:', error);
          Swal.fire({
            title: 'Error',
            text: error.message || 'Error al procesar el archivo CSV',
            icon: 'error'
          });
          setIsUploading(false);
        }
      };
      
      reader.onerror = (error) => {
        console.error('Error al leer el archivo:', error);
        Swal.fire({
          title: 'Error',
          text: 'Error al leer el archivo. Asegúrate de que no esté dañado o en uso por otro programa.',
          icon: 'error'
        });
        setIsUploading(false);
      };

      try {
        reader.readAsText(file, 'UTF-8');
      } catch (error) {
        console.error('Error al iniciar la lectura del archivo:', error);
        Swal.fire({
          title: 'Error',
          text: 'No se pudo leer el archivo. Verifica que sea un archivo CSV válido.',
          icon: 'error'
        });
        setIsUploading(false);
      }
      return;
    }

    // Lectura de Excel
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        console.log('Iniciando lectura del archivo Excel...');
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        processWorkbook(workbook);
      } catch (error) {
        console.error('Error al procesar el archivo Excel:', error);
        Swal.fire({
          title: 'Error',
          text: error.message || 'Error al procesar el archivo Excel',
          icon: 'error'
        });
        setIsUploading(false);
      }
    };
    
    reader.onerror = (error) => {
      console.error('Error al leer el archivo:', error);
      Swal.fire({
        title: 'Error',
        text: 'Error al leer el archivo. Asegúrate de que no esté dañado o en uso por otro programa.',
        icon: 'error'
      });
      setIsUploading(false);
    };
    
    try {
      reader.readAsArrayBuffer(file);
    } catch (error) {
      console.error('Error al iniciar la lectura del archivo:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo leer el archivo. Verifica que sea un archivo Excel válido.',
        icon: 'error'
      });
      setIsUploading(false);
    }
  };

  const processExcelData = async (patients) => {
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append('idTaller', turnoSeleccionado.idTaller);
      formData.append('taller', turnoSeleccionado.nombreTaller);
      formData.append('dias', JSON.stringify(turnoSeleccionado.dias));
      formData.append('periodicidad', turnoSeleccionado.periodicidad);
      
      // Add patients data
      formData.append('pacientes', JSON.stringify(patients));

      const response = await apiRaw(`/talleres/importar-excel`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      
      if (data.error) {
        throw new Error(data.error);
      }
      
      // Mostrar reporte detallado si existen resultados
      if (data.resultados) {
        const { exitosos, omitidos, errores, detalles } = data.resultados;
        
        // Construir HTML del reporte
        let reporteHTML = `
          <div style={{ textAlign: 'left' }}>
            <p><strong>Resumen del proceso:</strong></p>
            <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
              <li style={{ color: '#27ae60', fontWeight: 'bold' }}>✓ Inscritos exitosamente: ${exitosos}</li>
              ${omitidos > 0 ? `<li style={{ color: '#f39c12', fontWeight: 'bold' }}>⊘ Omitidos (ya inscritos): ${omitidos}</li>` : ''}
              ${errores > 0 ? `<li style={{ color: '#e74c3c', fontWeight: 'bold' }}>✗ Errores: ${errores}</li>` : ''}
            </ul>
        `;
        
        if (detalles && detalles.length > 0) {
          // Mostrar solo errores y advertencias
          const problemasDetallados = detalles.filter(d => d.estado === 'error' || (d.advertencia && d.estado === 'éxito'));
          if (problemasDetallados.length > 0) {
            reporteHTML += `
              <p><strong>Detalles de problemas:</strong></p>
              <div style={{ maxHeight: '300px', overflowY: 'auto', backgroundColor: '#f9f9f9', padding: '10px', borderRadius: '4px', fontSize: '12px' }}>
            `;
            problemasDetallados.forEach(detalle => {
              if (detalle.estado === 'error') {
                reporteHTML += `<p style={{ color: '#e74c3c', margin: '5px 0' }}><strong>Fila ${detalle.fila}:</strong> ${detalle.mensaje}</p>`;
              } else if (detalle.advertencia) {
                reporteHTML += `<p style={{ color: '#f39c12', margin: '5px 0' }}><strong>Fila ${detalle.fila}:</strong> ${detalle.advertencia}</p>`;
              }
            });
            reporteHTML += '</div>';
          }
        }
        
        reporteHTML += '</div>';
        
        Swal.fire({
          title: exitosos > 0 ? '¡Proceso completado!' : 'Proceso con problemas',
          html: reporteHTML,
          icon: exitosos > 0 ? 'success' : 'warning',
          confirmButtonText: 'Aceptar'
        });
      } else {
        Swal.fire('¡Éxito!', 'Pacientes cargados correctamente', 'success');
      }
      
      cargarPacientes();
      cargarTurnos();

      if (data.resultados && data.resultados.errores === 0) {
        closeImportModal();
      }
    } catch (error) {
      console.error('Error al cargar pacientes desde Excel:', error);
      Swal.fire('Error', 'Error al cargar pacientes desde Excel: ' + error.message, 'error');
    } finally {
      setIsUploading(false);
    }
  };

  const inscribirPacienteExistente = (paciente) => {
    const formData = new FormData();
    
    // Datos del paciente
    formData.append('idPaciente', paciente.id);
    formData.append('nombrePaciente', paciente.nombre);
    formData.append('telefono', paciente.telefono || '');
    
    // Datos del taller
    formData.append('idTaller', turnoSeleccionado.idTaller);
    formData.append('taller', turnoSeleccionado.nombreTaller);
    formData.append('dias', JSON.stringify(turnoSeleccionado.dias));
    formData.append('periodicidad', turnoSeleccionado.periodicidad);

    // Enviar a la API
    apiRaw(`/talleres/inscripcion-existente`, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Error en la solicitud');
      }
      return response.json();
    })
    .then(data => {
      if (data.error) {
        Swal.fire('Error', data.error, 'error');
      } else {
        Swal.fire('¡Éxito!', 'Paciente inscrito al taller correctamente', 'success');
        cargarPacientes();
        cargarTurnos();
        setModalSeleccionarPacienteIsOpen(false);
      }
    })
    .catch(error => {
      console.error('Error al inscribir paciente:', error);
      Swal.fire('Error', 'Ocurrió un error al inscribir al paciente', 'error');
    });
  };

  const [modalDatosPacienteIsOpen, setModalDatosPacienteIsOpen] = useState(false);

  const [catalogoEscolaridad, setCatalogoEscolaridad] = useState([]);
  const [catalogoEstadoCivil, setCatalogoEstadoCivil] = useState([]);
  const [catalogoMotivosConsulta, setCatalogoMotivosConsulta] = useState([]);
  const [catalogoMunicipios, setCatalogoMunicipios] = useState([]);
  const [catalogoReligiones, setCatalogoReligiones] = useState([]);
  const [catalogoServiciosSalud, setCatalogoServiciosSalud] = useState([]);
  const [catalogoSexo, setCatalogoSexo] = useState([]);
  const [catalogoComoEntero, setCatalogoComoEntero] = useState([]);

  const [idPacienteSeleccionado, setIdPacienteSeleccionado] = useState("");
  const [nombrePaciente, setNombrePaciente] = useState("");
  const [telefonoPaciente, setTelefonoPaciente] = useState("");
  const [edadPaciente, setEdadPaciente] = useState("");
  const [ocupacion, setOcupacion] = useState("");
  const [sexo, setSexo] = useState("");
  const [escolaridad, setEscolaridad] = useState("");
  const [estadoCivil, setEstadoCivil] = useState("");
  const [servicioSalud, setServicioSalud] = useState("");
  const [religion, setReligion] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [motivoConsulta, setMotivoConsulta] = useState("");
  const [comoEntero, setComoEntero] = useState("");

  const [tab, setTab] = useState('perfil');
  const [btnEstado, setBtnEstado] = useState();
  const [btnFecha, setBtnFecha] = useState();

  const [nombreCategoria, setNombreCategoria] = useState();
  const [nombreServicio, setNombreServicio] = useState();
  const [nombreTerapeuta, setNombreTerapeuta] = useState();
  const [estado, setEstado] = useState();

  const [opcionCrud, setOpcionCrud] = useState(); //Nuevo, Existente

  const horas = ["08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", "18:00", "18:30", "19:00", "19:30", "20:00"];

  const obtenerServicios = async () => {

    setServicios([]);
    if (!categoriaSeleccionada) return;   // sin CESECO no hay qué pedir (pedía /servicios/tienda/ sin id → 404)

    try {

      apiRaw(`/servicios/tienda/${categoriaSeleccionada}`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {
          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar CESECOS',
              text: data.error,
            });
          } else {
            setServicios(data.servicios || []);
          }

        })
        .catch(error => console.error('Error al cargar programas:', error));


    } catch (error) {
      console.error('Error al obtener los progamas disponibles:', error);
    }

  };

  const cargarTerapeutas = async () => {

    setListaTerapeutas([]);

    try {
      apiRaw(`/servicios/${servicioSeleccionado}/terapeutas`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(data => {

          if (data.error) {
            Swal.fire({
              icon: 'warning',
              title: 'Error al cargar terapeutas',
              text: data.error,
            });
          } else {
            setListaTerapeutas(data || []);
          }

        })
        .catch(error => console.error('Error al cargar terapeutas:', error));

    } catch (error) {
      console.error('Error al obtener terapeutas:', error);
    }


  };

  const cargarPacientes = () => {
    //pacientes del taller
    setPacientesLoading(true);
    
    // Obtener fecha y hora de la sesión seleccionada
    const fechaSesion = turnoSeleccionado?.fecha || turnoSeleccionado?.dias?.[0]?.dia;
    const horaSesion = turnoSeleccionado?.horaInicio || turnoSeleccionado?.dias?.[0]?.horaInicio;
    
    if (!fechaSesion || !horaSesion) {
      console.error('No se encontró fecha u hora de la sesión');
      setPacientesLoading(false);
      return;
    }
    
    apiRaw(`/talleres/${turnoSeleccionado.idTaller}/pacientes`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        setPacientes(data.pacientes || []);
      })
      .catch(error => console.error('Error al cargar pacientes del taller:', error))
      .finally(() => setPacientesLoading(false));

    //todos los pacientes
    apiRaw(`/pacientes`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        setAllPacientes(data.pacientes || []);
      })
      .catch(error => console.error('Error al cargar todos los pacientes:', error));
  };

  const actualizarEstadoAsistencia = async (idTurno, nuevoEstado) => {
    try {
      const response = await apiRaw(`/talleres/participantes/${idTurno}/estado`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idTurno: idTurno,
          estado: nuevoEstado
        })
      });

      const data = await response.json();

      if (data.success) {
        // Recargar la lista de pacientes para reflejar el cambio
        cargarPacientes();
        Swal.fire({
          icon: 'success',
          title: 'Estado actualizado',
          text: `Asistencia marcada como ${nuevoEstado}`,
          timer: 1500,
          showConfirmButton: false
        });
      } else {
        throw new Error(data.error || 'Error al actualizar estado');
      }
    } catch (error) {
      console.error('Error al actualizar estado de asistencia:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'No se pudo actualizar el estado de asistencia'
      });
    }
  };

  /*
  const obtenerComentarios = async () => {

    setComentarios([]);

    if (turnoSeleccionado.idPaciente != null) {
      try {
        apiRaw(`/pacientes/${turnoSeleccionado.idPaciente}/comentarios`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              Swal.fire({
                icon: 'warning',
                title: 'Error al cargar comentarios',
                text: data.error,
              });
            } else {
              setComentarios(data.comentarios);
            }

          })
          .catch(error => console.error('Error al cargar comentarios:', error));

      } catch (error) {
        console.error('Error al obtener comentarios:', error);
      }
    }

  };
  */
  const obtenerCitasProgramadas = async () => {

    setCitasProgramadas([]);

    // Para talleres: cargar sesiones del taller
    if (turnoSeleccionado.idTaller) {
      try {
        const response = await apiRaw(`/talleres/${turnoSeleccionado.idTaller}/sesiones-inscritos`, {
          method: 'GET',
        });
        const data = await response.json();
        
        if (data.error) {
          Swal.fire({
            icon: 'warning',
            title: 'Error al cargar las sesiones del taller',
            text: data.error,
          });
        } else {
          // Formatear sesiones para mostrarlas como "citas"
          const sesionesFormateadas = (data.sesiones || []).map(sesion => ({
            ...sesion,
            // Compatibilidad con formato de citas
            fechaSesion: sesion.fecha,
            horarioInicio: sesion.horaInicio?.substring(0, 5),
            horarioFin: sesion.horaFin?.substring(0, 5),
            tipo: 'sesion' // Para distinguir de citas tradicicionales
          }));
          setCitasProgramadas(sesionesFormateadas);
        }
      } catch (error) {
        console.error('Error al obtener las sesiones del taller:', error);
      }
    }
    // turnos_talleres retirado (tabla eliminada): sin fallback de citas tradicionales.
  };

  const obtenerCitasHistorial = async () => {
    // turnos_talleres retirado (tabla eliminada): sin historial de citas de taller.
    setCitasHistorial([]);
  };

  const obtenerSalasDisponibles = async () => {

    setSalas([]);
    setSalasDisponibles([]);

    if (turnoSeleccionado && categoriaSeleccionada > 0 && turnoSeleccionado.dias && turnoSeleccionado.dias.length > 0 && terapeutaSeleccionado) {
      try {
        const { dia, horaInicio, horaFin } = turnoSeleccionado.dias[0];

        apiRaw(`/salas/disponibles?fecha=${dia}&horaInicio=${horaInicio}&horaFin=${horaFin}&idCategoria=${categoriaSeleccionada}&idTerapeuta=${terapeutaSeleccionado}&idTurno=${turnoSeleccionado.idTurno}`, {
          method: 'GET',
        })
          .then(response => response.json())
          .then(data => {
            if (data.error) {
              if (turnoSeleccionado.estado != 'Asignado') {
                Swal.fire({
                  icon: 'warning',
                  title: '',
                  text: data.error,
                });
              }
            } else {
              setSalas(data.salas || []);
              setSalasDisponibles(data.salasDisponibles || []);

            }

          })
          .catch(error => console.error('Error al cargar salas disponibles:', error));


      } catch (error) {
        console.error('Error al obtener las salas disponibles:', error);
      }
    }
  };

  const cargarCatalogos = () => {
    //MOTIVO INACTIVO
    apiRaw(`/catalogos/motivos_inactivo`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMotivosInactivo(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo motivos_inactivo:', error));

    //ESCOLARIDAD
    apiRaw(`/catalogos/escolaridad`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoEscolaridad(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo escolaridad:', error));

    //ESTADO CIVIL    
    apiRaw(`/catalogos/estado_civil`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoEstadoCivil(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo estado civil:', error));

    //MOTIVOS DE CONSULTA    
    apiRaw(`/catalogos/motivos_de_consulta`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMotivosConsulta(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo motivos de consulta:', error));

    //MUNICIPIOS    
    apiRaw(`/catalogos/municipios`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoMunicipios(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo municipios:', error));

    //RELIGIONES    
    apiRaw(`/catalogos/religiones`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoReligiones(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo religiones:', error));

    //SERVICIOS DE SALUD   
    apiRaw(`/catalogos/servicios_de_salud`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoServiciosSalud(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo servicios de salud:', error));

    //SEXO   
    apiRaw(`/catalogos/sexo`, { method: 'GET', }).then(response => response.json())
      .then(data => {
        setCatalogoSexo(data.catalogo);
      }).catch(error => console.error('Error al cargar el catálogo sexo:', error));

    //COMO ENTERO
    apiRaw(`/catalogos/como_entero`)
      .then(res => res.json())
      .then(data => setCatalogoComoEntero(data.catalogo || []));

  };

  const checkDatosCompletos = () => {
    /*
    if (nombre == '' || nombre == null) {
      Swal.fire('Atención!', 'Debes escribir el nombre del paciente', 'warning');
    } else if (telefono == '' || telefono == null) {
      Swal.fire('Atención!', 'Debes escribir el teléfono del paciente', 'warning');
    } else if (servicioSeleccionado == null || servicioSeleccionado == '') {
      Swal.fire('Atención!', 'Debes seleccionar un programa', 'warning');
    } else if (nuevoEstado == 'Asignado' && (terapeutaSeleccionado == null || terapeutaSeleccionado == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un terapeuta', 'warning');
    } else if (nuevoEstado == 'Asignado' && (salaSeleccionada == null || salaSeleccionada == '')) {
      Swal.fire('Atención!', 'Debes seleccionar una sala', 'warning');
    } else if ((nuevoEstado == 'Inactivo' || nuevoEstado == 'Finalizado') && (motivoInactivo == null || motivoInactivo == '')) {
      Swal.fire('Atención!', 'Debes seleccionar un motivo', 'warning');
    } else {
      setBtnEstado('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateText(turnoSeleccionado.idTurno);

    }
    */
    setBtnEstado('Editar');
    handleUpdateText(turnoSeleccionado.idTurno);

  }

  const checkComentarioCompleto = (tipo) => {
    if (nuevoComentario == '' || nuevoComentario == null) {
      Swal.fire('Atención!', 'Debes escribir un comentario', 'warning');
    } else {
      handleInsertComment(turnoSeleccionado.idTurno, tipo);
    }
  }

  const checkDatosPrograma = () => {

    if (nuevaFecha == '' || nuevaFecha == null) {
      Swal.fire('Atención!', 'Debes seleccionar una fecha', 'warning');
    } else if (periodicidad == '' || periodicidad == null) {
      Swal.fire('Atención!', 'Debes seleccionar la periodicidad', 'warning');
    } else {
      setBtnFecha('Editar');
      //alertAsignarSala(turnoSeleccionado);
      handleUpdateDate(turnoSeleccionado.idTurno);
    }
  }

  // Handlers para gestión de sesiones del taller
  const handleEditarSesion = (sesion) => {
    setSesionEditando(sesion.idSesion);
    setSesionEditandoValores({
      fecha: sesion.fecha,
      horaInicio: sesion.horaInicio?.substring(0, 5) || '',
      horaFin: sesion.horaFin?.substring(0, 5) || ''
    });
  };

  const handleCancelarEdicionSesion = () => {
    setSesionEditando(null);
    setSesionEditandoValores({ fecha: '', horaInicio: '', horaFin: '' });
  };

  const handleGuardarSesion = async (idSesion) => {
    try {
      const response = await apiRaw(`/talleres/sesiones/${idSesion}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idSesion: idSesion,
          fecha: sesionEditandoValores.fecha,
          horaInicio: sesionEditandoValores.horaInicio,
          horaFin: sesionEditandoValores.horaFin
        }),
      });

      const data = await response.json();

      if (data.error) {
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar la sesión',
          text: data.error,
        });
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Sesión actualizada',
          text: 'La sesión se actualizó correctamente.',
          timer: 2000,
          showConfirmButton: false
        });
        setSesionEditando(null);
        setSesionEditandoValores({ fecha: '', horaInicio: '', horaFin: '' });
        await obtenerCitasProgramadas();
        cargarTurnos(); // Refrescar el calendario
      }
    } catch (error) {
      console.error('Error al guardar la sesión:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo guardar la sesión. Inténtalo de nuevo.',
      });
    }
  };

  const handleEliminarSesion = async (sesion) => {
    const result = await Swal.fire({
      title: '¿Cancelar esta sesión?',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p><b>Sesión ${sesion.numeroSesion}</b></p>
          <p>${moment(sesion.fecha).format('dddd D [de] MMMM [de] YYYY')}</p>
          <p>${sesion.horaInicio?.substring(0, 5)} - ${sesion.horaFin?.substring(0, 5)}</p>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, cancelar sesión',
      cancelButtonText: 'No cancelar'
    });

    if (result.isConfirmed) {
      try {
        const response = await apiRaw(`/talleres/sesiones/${sesion.idSesion}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            idSesion: sesion.idSesion
          }),
        });

        const data = await response.json();

        if (data.error) {
          Swal.fire({
            icon: 'error',
            title: 'Error al cancelar la sesión',
            text: data.error,
          });
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Sesión cancelada',
            text: `Se canceló la sesión y ${data.inscritosCancelados} inscripción(es).`,
            timer: 2000,
            showConfirmButton: false
          });
          await obtenerCitasProgramadas();
          cargarTurnos(); // Refrescar el calendario
        }
      } catch (error) {
        console.error('Error al eliminar la sesión:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cancelar la sesión. Inténtalo de nuevo.',
        });
      }
    }
  };

  const navigate = useNavigate();

  const handleEditarTaller = () => {
    if (turnoSeleccionado?.idTaller) {
      // Redirigir a la página de talleres con el idTaller en el state
      navigate('/dashboard/talleres', { state: { editarTallerId: turnoSeleccionado.idTaller } });
      onClose(); // Cerrar el modal
    }
  };

  const handleAgregarUnaCita = async () => {
    // Calcular la próxima cita a agendar
    let fechaBase = nuevaFecha;
    if (citasProgramadas.length > 0) {
      // Tomar la última cita futura
      const ultCita = citasProgramadas[citasProgramadas.length - 1];
      fechaBase = ultCita.dias[0].dia;
    }
    // Calcular la siguiente fecha según periodicidad
    let siguienteFecha = moment(fechaBase);
    if (periodicidad === 'Semanal') {
      siguienteFecha = siguienteFecha.add(7, 'days');
    } else if (periodicidad === 'Quincenal') {
      siguienteFecha = siguienteFecha.add(14, 'days');
    }
    const diaSemana = siguienteFecha.format('dddd');
    const fechaStr = siguienteFecha.format('D [de] MMMM [de] YYYY');
    const horaInicio = nuevaHoraInicio;
    const horaFin = nuevaHoraFin;
    // Mostrar confirmación
    const result = await Swal.fire({
      title: '¿Agregar una nueva cita?',
      html: `<b>Fecha:</b> ${fechaStr}<br/><b>Día:</b> ${diaSemana}<br/><b>Hora:</b> ${horaInicio} - ${horaFin}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, agendar',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      setNuevoComentario("");
      //await handleInsertComment(turnoSeleccionado.idTurno, 4);
      await handleNewAppointment(turnoSeleccionado.idTurno);
      await obtenerCitasProgramadas();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setNombre(turnoSeleccionado?.nombre || '');
      setTelefono(turnoSeleccionado?.telefono || '');

      setCategoriaSeleccionada(turnoSeleccionado?.idCategoriaSala || '');
      setServicioSeleccionado(turnoSeleccionado?.idServicio || '');
      setTerapeutaSeleccionado(turnoSeleccionado?.idTerapeuta || '');
      setSalaSeleccionada(turnoSeleccionado?.idSala || '');

      setNuevaFecha(turnoSeleccionado.dias[0].dia);
      setPeriodicidad(turnoSeleccionado.periodicidad);
      setNuevaHoraInicio(turnoSeleccionado.dias[0].horaInicio);
      setNuevaHoraFin(turnoSeleccionado.dias[0].horaFin);

      setNuevoEstado(turnoSeleccionado?.estado || '');

      setNombreCategoria(turnoSeleccionado?.nombreCategoria || '');
      setNombreServicio(turnoSeleccionado?.servicio || '');
      setNombreTerapeuta(turnoSeleccionado?.nombreTerapeuta || '');
      setEstado(turnoSeleccionado?.estado || '');

      setBtnEstado('Editar');
      setBtnFecha('Editar')
      setTab('perfil');

      setNuevoComentario("");

      cargarCatalogos();
      cargarPacientes();
      //obtenerComentarios();
      obtenerCitasProgramadas();
      obtenerCitasHistorial();

    }

  }, [isOpen, turnoSeleccionado]);


  useEffect(() => {
    if (!isOpen) return;
    obtenerServicios();

  }, [isOpen, categoriaSeleccionada]);

  const handleCategoriaSeleccionada = (e) => {
    setCategoriaSeleccionada(e.target.value)
    setServicioSeleccionado(null);
    obtenerServicios();
  }

  useEffect(() => {
    if (!isOpen) return;
    cargarTerapeutas();
  }, [isOpen, servicioSeleccionado]);

  const handleServicioSeleccionado = (e) => {
    setServicioSeleccionado(e.target.value)
    setTerapeutaSeleccionado(null);
    cargarTerapeutas();
  }

  useEffect(() => {
    if (!isOpen) return;
    obtenerSalasDisponibles();
  }, [isOpen, terapeutaSeleccionado]);


  useEffect(() => {
    if (isOpen) {
      //obtenerComentarios();
    }
  }, [comentarioActualizado]);

  useEffect(() => {
    if (isOpen) {
      obtenerCitasProgramadas();
    }
  }, [cancelarActualizado]);


  const handleTerapeutaSeleccionado = (e) => {
    setTerapeutaSeleccionado(e.target.value)
    setSalaSeleccionada(null);
    obtenerSalasDisponibles();
  }

  const handleCloseDatosPacienteModal = () => {
    setModalDatosPacienteIsOpen(false); // Cerrar el modal
  };

  const handleOpenDatosPacienteNuevoModal = () => {
    setOpcionCrud("Nuevo");

    setNombrePaciente("");
    setTelefonoPaciente("");
    setEdadPaciente("");
    setSexo("");
    setEscolaridad("");
    setEstadoCivil("");
    setOcupacion("");
    setServicioSalud("");
    setReligion("");
    setMunicipio("");
    setMotivoConsulta("");
    setComoEntero("");

    setModalDatosPacienteIsOpen(true);
  };

  const handleOpenDatosPacienteExistenteModal = (id) => {

    const paciente = pacientes.filter(item => item.id === id);

    setOpcionCrud("Existente");

    setIdPacienteSeleccionado(paciente[0].id);
    setNombrePaciente(paciente[0].nombre);
    setTelefonoPaciente(paciente[0].telefono);
    setEdadPaciente(paciente[0].edad);
    setSexo(paciente[0].idSexo || 0);
    setEscolaridad(paciente[0].idEscolaridad || 0);
    setEstadoCivil(paciente[0].idEstadoCivil || 0);
    setOcupacion(paciente[0].ocupacion);
    setServicioSalud(paciente[0].idServicioSalud || 0);
    setReligion(paciente[0].idReligion || 0);
    setMunicipio(paciente[0].idMunicipio || 0);
    setMotivoConsulta(paciente[0].idMotivoConsulta || 0);
    setComoEntero(paciente[0].idComoEntero || 0);

    setModalDatosPacienteIsOpen(true);
  };

  const obtenerTelefonoMasked = (telefono) => {
    if (!telefono) return 'Sin telefono';
    const digits = telefono.toString().replace(/\D/g, '');
    if (digits.length <= 4) return `***${digits}`;
    return `***${digits.slice(-4)}`;
  };

  const desinscribirPaciente = async (id, name) => {
    const result = await Swal.fire({
      title: '¿Desinscribir paciente del taller?',
      html: `<b>${escapeHtml(name)}</b><br/><span>Se quitara la vinculacion con este taller, no se elimina el paciente.</span>`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Si, desinscribir',
      cancelButtonText: 'Cancelar',
    });
    if (result.isConfirmed) {
      apiRaw(`/talleres/${turnoSeleccionado.idTaller}/pacientes/${id}`, { 
        method: 'DELETE',
      }).then(response => response.json())
        .then(data => {
          if (data.error) {
            Swal.fire(
              'Error',
              data.error,
              'error'
            );
          } else {
            Swal.fire(
              'Desinscrito',
              data.mensaje || 'El paciente fue desinscrito del taller.',
              'success'
            );
            cargarPacientes();
          }
        }).catch(error => {
          console.error('Error al eliminar paciente:', error);
          Swal.fire(
            'Error',
            'Ocurrio un problema al intentar desinscribir al paciente.',
            'error'
          );
        });
    }
  }

  const guardarPaciente = () => {
    if (nombrePaciente == '') {
      Swal.fire('Alerta!', 'Debes escribir el nombre del paciente', 'warning');
    } else if (telefonoPaciente == '') {
      Swal.fire('Alerta!', 'Debes escribir el teléfono del paciente', 'warning');
    } else if (edadPaciente == '') {
      Swal.fire('Alerta!', 'Debes escribir la edad del paciente', 'warning');
    } else if (sexo == '') {
      Swal.fire('Alerta!', 'Debes seleccionar una opción en sexo', 'warning');
    } else {

      if (opcionCrud === "Nuevo") {
        const formData = new FormData();

        formData.append('nombrePaciente', nombrePaciente);
        formData.append('telefono', telefonoPaciente);
        formData.append('edad', edadPaciente);
        formData.append('sexo', sexo);
        formData.append('escolaridad', escolaridad);
        formData.append('estadoCivil', estadoCivil);
        formData.append('ocupacion', ocupacion);
        formData.append('servicioSalud', servicioSalud);
        formData.append('religion', religion);
        formData.append('municipio', municipio);
        formData.append('motivoConsulta', motivoConsulta);
        formData.append('comoEntero', comoEntero);

        formData.append('idTaller', turnoSeleccionado.idTaller);
        formData.append('taller', turnoSeleccionado.nombreTaller);
        formData.append('dias', JSON.stringify(turnoSeleccionado.dias));
        formData.append('periodicidad', turnoSeleccionado.periodicidad);

        //damos de alta el paciente y lo inscribimos al taller
        apiRaw(`/talleres/inscripcion-manual`, {
          method: 'POST',
          body: formData
        }).then(response => {
          if (!response.ok) {
            throw new Error('La solicitud no fue exitosa');
          }
          return response.json();
        })
          .then(data => {
            if (data.error) {
              avisoError(data.error);
            } else {
              avisoExito(data.mensaje);
              cargarPacientes();
              cargarTurnos();
              handleCloseDatosPacienteModal();
            }
          })
          .catch(() => {
            avisoError('No se pudo inscribir al paciente. Intenta de nuevo.');
          });
      } else {
        const payload = {
          nombrePaciente,
          telefono: telefonoPaciente,
          edad: edadPaciente,
          sexo,
          escolaridad,
          estadoCivil,
          ocupacion,
          servicioSalud,
          religion,
          municipio,
          motivoConsulta,
          comoEntero,
        };

        apiRaw(`/pacientes/${idPacienteSeleccionado}/sin-turno`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }).then(response => {
          if (!response.ok) {
            throw new Error('La solicitud no fue exitosa');
          }
          return response.json();
        })
          .then(data => {
            if (data.error) {
              avisoError(data.error);
            } else {
              avisoExito(data.mensaje);
              cargarPacientes();
              handleCloseDatosPacienteModal();
            }
          })
          .catch(() => {
            avisoError('No se pudieron guardar los datos del paciente. Intenta de nuevo.');
          });
      }

    }

  };


  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Detalle de la cita"
        ariaHideApp={false}
        className="modal-admin"
        overlayClassName="overlay-admin"
      >
        {/* HEADER */}
        <div className='deFlexBtnsModal taller-header'>
          <div className="taller-header-info">
            <div className="taller-title-block">
              <div className="taller-pill">Taller</div>
              <h3 className="taller-title">{turnoSeleccionado?.nombreTaller || 'Taller'}</h3>
              {(nombreCategoria || nombreServicio) && (
                <div className="taller-subtitle">{nombreServicio || 'Programa'} • {nombreCategoria || 'CESECO'}</div>
              )}
            </div>
            <div className="taller-stats">
              <div className="taller-stat-card">
                <span className="taller-stat-label">Capacidad</span>
                  {pacientesLoading ? (
                    <span className="taller-stat-value skeleton skeleton-text" style={{ width: '90px' }} />
                  ) : (
                    <span className="taller-stat-value">{cupoMaximo ? `${cupoMaximo} lugares` : '—'}</span>
                  )}
              </div>
              <div className="taller-stat-card">
                <span className="taller-stat-label">Inscritos</span>
                  {pacientesLoading ? (
                    <span className="taller-stat-value skeleton skeleton-text" style={{ width: '40px' }} />
                  ) : (
                    <span className="taller-stat-value">{inscritosCount}</span>
                  )}
              </div>
              <div className="taller-stat-card">
                <span className="taller-stat-label">Disponibles</span>
                  {pacientesLoading ? (
                    <span className="taller-stat-value skeleton skeleton-text" style={{ width: '70px' }} />
                  ) : (
                    <span className="taller-stat-value">{cupoMaximo ? `${cupoDisponible} libres` : '—'}</span>
                  )}
              </div>
            </div>
          </div>
          <span className="close" onClick={onClose}>&times;</span>
        </div>

        {/* TABS SUPERIORES */}
        <div className="tabs">
          {TAB_LIST.map(tabItem => (
            <button
              key={tabItem.key}
              className={`tab-label${tab === tabItem.key ? ' active' : ''}`}
              onClick={() => setTab(tabItem.key)}
            >
              {tabItem.type === 'fa' ? (
                <FontAwesomeIcon icon={tabItem.icon} style={{ marginRight: 8 }} />
              ) : (
                <tabItem.icon style={{ marginRight: 8, fontSize: 18, verticalAlign: 'middle' }} />
              )}
              {tabItem.label}
            </button>
          ))}
        </div>

        {/* CONTENIDO DE TABS */}
        <div className="tab-content">
          {/* PERFIL */}
          {tab === 'perfil' && (
            <div className="profile-card">
              {btnEstado === 'Editar' ? (
                <>
                  {/*}
                  <div className="profile-field">
                    <FaUser className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Nombre completo *</span>
                      <span className="profile-value">{nombre}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaPhone className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Teléfono de contacto *</span>
                      <span className="profile-value">{telefono}</span>
                    </div>
                  </div>
                  {*/}
                  <div className="profile-field">
                    <FaTools className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Taller *</span>
                      <span className="profile-value">{turnoSeleccionado.nombreTaller}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaBuilding className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Unidad CESECO *</span>
                      <span className="profile-value">{nombreCategoria}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaBook className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Programa *</span>
                      <span className="profile-value">{nombreServicio}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaUserMd className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Terapeuta *</span>
                      <span className="profile-value">{nombreTerapeuta}</span>
                    </div>
                  </div>
                  <div className="profile-field">
                    <FaDoorOpen className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Sala *</span>
                      <span className="profile-value">{turnoSeleccionado?.nombreSala}</span>
                    </div>
                  </div>

                  {/*}
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1 }}>
                      <span className="profile-label">Estado *</span>
                      <span className="profile-value">{estado}</span>
                    </div>
                  </div>
                  {(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                    <div className="profile-field">
                      <FaInfoCircle className="profile-icon" />
                      <div style={{ flex: 1 }}>
                        <span className="profile-label">Motivo *</span>
                        <span className="profile-value">{motivoInactivo}</span>
                      </div>
                    </div>
                  )}
                  {*/}

                  {/* Botón para editar taller */}
                  <div className="profile-save-btn-container" style={{ marginTop: 24 }}>
                    <button className="profile-edit-btn" onClick={handleEditarTaller}>
                      <FaEdit style={{ marginRight: 6 }} />
                      Editar Taller
                    </button>
                  </div>

                </>
              ) : (
                <>
                  {/*}
                <div className="profile-field">
                  <FaUser className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Nombre completo *</span>
                    <span className="profile-input-icon"><FaUser /></span>
                    <input className="profile-input" type="text" value={nombre} onChange={e => setNombre(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaPhone className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Teléfono de contacto *</span>
                    <span className="profile-input-icon"><FaPhone /></span>
                    <input className="profile-input" type="text" value={telefono} onChange={e => setTelefono(e.target.value)} style={{ paddingLeft: 38 }} />
                  </div>
                </div>
                <div className="profile-field">
                  <FaBuilding className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Unidad CESECO *</span>
                    <span className="profile-input-icon"><FaBuilding /></span>
                    <select
                      className="profile-select"
                      value={categoriaSeleccionada || ""}
                      onChange={handleCategoriaSeleccionada}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar CESECO</option>
                      {categorias.map(c => (
                        <option key={c.idCategoria} value={c.idCategoria}>
                          {c.categoria}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaBook className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Programa *</span>
                    <span className="profile-input-icon"><FaBook /></span>
                    <select
                      className="profile-select"
                      value={servicioSeleccionado || ""}
                      onChange={handleServicioSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccionar Programa</option>
                      {servicios.map(s => (
                        <option key={s.idServicio} value={s.idServicio}>
                          {s.titulo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaUserMd className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Terapeuta *</span>
                    <span className="profile-input-icon"><FaUserMd /></span>
                    <select
                      className="profile-select"
                      value={terapeutaSeleccionado || ""}
                      onChange={handleTerapeutaSeleccionado}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Elegir terapeuta</option>
                      {listaTerapeutas.map(t => {
                        const rolLabel = t.rol === 'terapeuta' ? 'Terapeuta' :
                                        t.rol === 'coord_programa' ? 'Coord. Programa' :
                                        t.rol === 'coord_ceseco' ? 'Coord. CESECO' : t.rol;
                        return (
                          <option key={t.idUsuario} value={t.idUsuario}>
                            {t.nombre} ({rolLabel})
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="profile-field">
                  <FaDoorOpen className="profile-icon" />
                  <div style={{ flex: 1, position: 'relative' }}>
                    <span className="profile-label">Sala *</span>
                    <span className="profile-input-icon"><FaDoorOpen /></span>
                    <select
                      className="profile-select"
                      value={salaSeleccionada || ""}
                      onChange={e => setSalaSeleccionada(e.target.value)}
                      required
                      style={{ paddingLeft: 38 }}
                    >
                      <option value="" disabled>Seleccione una sala</option>
                      {salas.map((s) => {
                        const estaDisponible = salasDisponibles.some(sd => sd.idSala === s.idSala);
                        return (
                          <option
                            key={s.idSala}
                            value={s.idSala}
                            disabled={!estaDisponible}
                          >
                            {s.nombre} {estaDisponible ? '' : '(No disponible)'}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                {*/}
                  <div className="profile-field">
                    <FaInfoCircle className="profile-icon" />
                    <div style={{ flex: 1, position: 'relative' }}>
                      <span className="profile-label">Estado *</span>
                      <span className="profile-input-icon"><FaInfoCircle /></span>
                      <select
                        className="profile-select"
                        value={nuevoEstado}
                        onChange={e => setNuevoEstado(e.target.value)}
                        required
                        style={{ paddingLeft: 38 }}
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="Asignado">Asignado</option>
                        <option value="Finalizado">Finalizado</option>
                        <option value="Inactivo">Inactivo</option>
                      </select>
                    </div>
                  </div>
                  {/*(nuevoEstado === 'Inactivo' || nuevoEstado === 'Finalizado') && (
                    <div className="profile-field">
                      <FaInfoCircle className="profile-icon" />
                      <div style={{ flex: 1, position: 'relative' }}>
                        <span className="profile-label">Motivo *</span>
                        <span className="profile-input-icon"><FaInfoCircle /></span>
                        <select
                          className="profile-select"
                          value={motivoInactivo || ""}
                          onChange={e => setMotivoInactivo(e.target.options[e.target.selectedIndex].text)}
                          required
                          style={{ paddingLeft: 38 }}
                        >
                          <option value="" disabled>Seleccione un motivo</option>
                          {catalogoMotivosInactivo.map((cat) => (
                            <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )*/}
                </>
              )}
              {/*
              <div className="profile-save-btn-container">
                <button className="profile-edit-btn" onClick={() => {
                  if (btnEstado === 'Editar') {
                    setBtnEstado('Guardar');
                  } else {
                    checkDatosCompletos();
                  }
                }}>
                  {btnEstado === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                  {btnEstado === 'Editar' ? 'Editar' : 'Guardar'}
                </button>
              </div>
              */}
            </div>
          )}

          {/* CITAS */}
          {tab === 'citas' && (
            <div className="card-section citas-modern">
              {/* Mostrar gestión de sesiones para talleres */}
              {turnoSeleccionado.idTaller ? (
                <>
                  <div className="citas-header-row">
                    <div className="citas-header-title">
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8, fontSize: 22 }} />
                      <span style={{ fontWeight: 700, fontSize: 18 }}>Sesiones del Taller</span>
                    </div>
                  </div>
                  
                  {citasProgramadas && citasProgramadas.length > 0 ? (
                    <div style={{ marginTop: 20 }}>
                      {citasProgramadas.map((sesion, idx) => {
                        const estaEditando = sesionEditando === sesion.idSesion;
                        const fechaMoment = moment(sesion.fecha);
                        const diaSemana = fechaMoment.format('dddd');
                        const fechaFormateada = fechaMoment.format('D [de] MMMM [de] YYYY');
                        
                        return (
                          <div key={sesion.idSesion} style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: 8,
                            padding: 16,
                            marginBottom: 12,
                            backgroundColor: estaEditando ? '#f0f9ff' : '#fff'
                          }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                              <div style={{ flex: 1 }}>
                                <div style={{ 
                                  fontSize: 16, 
                                  fontWeight: 600, 
                                  color: '#333',
                                  marginBottom: 10
                                }}>
                                  Sesión {sesion.numeroSesion}
                                </div>
                                
                                {!estaEditando ? (
                                  <>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8 }} />
                                      <span style={{ fontSize: 14, color: '#555' }}>
                                        <b>{diaSemana}</b>, {fechaFormateada}
                                      </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                      <FontAwesomeIcon icon={faClock} style={{ color: '#14a7a3', marginRight: 8 }} />
                                      <span style={{ fontSize: 14, color: '#555' }}>
                                        {sesion.horaInicio?.substring(0, 5)} - {sesion.horaFin?.substring(0, 5)} hrs
                                      </span>
                                    </div>
                                  </>
                                ) : (
                                  <div style={{ marginTop: 10 }}>
                                    <div style={{ marginBottom: 12 }}>
                                      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>
                                        Fecha
                                      </label>
                                      <input
                                        type="date"
                                        value={sesionEditandoValores.fecha}
                                        onChange={e => setSesionEditandoValores({
                                          ...sesionEditandoValores,
                                          fecha: e.target.value
                                        })}
                                        style={{
                                          width: '100%',
                                          padding: '8px 12px',
                                          border: '1px solid #ccc',
                                          borderRadius: 4,
                                          fontSize: 14
                                        }}
                                      />
                                    </div>
                                    <div style={{ display: 'flex', gap: 12 }}>
                                      <div style={{ flex: 1 }}>
                                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>
                                          Hora inicio
                                        </label>
                                        <input
                                          type="time"
                                          value={sesionEditandoValores.horaInicio}
                                          onChange={e => setSesionEditandoValores({
                                            ...sesionEditandoValores,
                                            horaInicio: e.target.value
                                          })}
                                          style={{
                                            width: '100%',
                                            padding: '8px 12px',
                                            border: '1px solid #ccc',
                                            borderRadius: 4,
                                            fontSize: 14
                                          }}
                                        />
                                      </div>
                                      <div style={{ flex: 1 }}>
                                        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4, color: '#555' }}>
                                          Hora fin
                                        </label>
                                        <input
                                          type="time"
                                          value={sesionEditandoValores.horaFin}
                                          onChange={e => setSesionEditandoValores({
                                            ...sesionEditandoValores,
                                            horaFin: e.target.value
                                          })}
                                          style={{
                                            width: '100%',
                                            padding: '8px 12px',
                                            border: '1px solid #ccc',
                                            borderRadius: 4,
                                            fontSize: 14
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                              
                              <div style={{ display: 'flex', gap: 8, marginLeft: 16 }}>
                                {!estaEditando ? (
                                  <>
                                    <button
                                      onClick={() => handleEditarSesion(sesion)}
                                      style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#1976d2',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6
                                      }}
                                    >
                                      <FaEdit /> Editar
                                    </button>
                                    <button
                                      onClick={() => handleEliminarSesion(sesion)}
                                      style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#d32f2f',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTimesCircle} /> Cancelar
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      onClick={() => handleGuardarSesion(sesion.idSesion)}
                                      style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#2e7d32',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontWeight: 500,
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 6
                                      }}
                                    >
                                      <FaSave /> Guardar
                                    </button>
                                    <button
                                      onClick={handleCancelarEdicionSesion}
                                      style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#757575',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: 4,
                                        cursor: 'pointer',
                                        fontSize: 14,
                                        fontWeight: 500
                                      }}
                                    >
                                      Cancelar
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div style={{ 
                      textAlign: 'center', 
                      padding: 40, 
                      color: '#999',
                      fontSize: 14 
                    }}>
                      No hay sesiones programadas para este taller.
                    </div>
                  )}
                </>
              ) : (
                /* UI original para citas de pacientes */
                <>
                  <div className="citas-header-row">
                    <div className="citas-header-title">
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#14a7a3', marginRight: 8, fontSize: 22 }} />
                      <span style={{ fontWeight: 700, fontSize: 18 }}>Próxima cita</span>
                    </div>
                    <button className="section-edit-btn" onClick={() => {
                      if (btnFecha === 'Editar') {
                        setBtnFecha('Guardar');
                      } else {
                        checkDatosPrograma();
                      }
                    }}>
                      {btnFecha === 'Editar' ? <FaEdit style={{ marginRight: 6 }} /> : <FaSave style={{ marginRight: 6 }} />}
                      {btnFecha === 'Editar' ? 'Editar' : 'Guardar'}
                    </button>
                  </div>
                  <div className="citas-fields-row">
                    {btnFecha === 'Editar' ? (
                      <>
                        <div className="cita-field-card">
                          <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon" />
                          <div>
                            <div className="cita-label">Fecha</div>
                            <div className="cita-value">{moment(turnoSeleccionado.dias[0].dia).format('dddd D [de] MMMM [de] YYYY')}</div>
                          </div>
                        </div>
                        <div className="cita-field-card">
                          <FontAwesomeIcon icon={faClock} className="cita-icon" />
                          <div>
                            <div className="cita-label">Hora</div>
                            <div className="cita-value">{turnoSeleccionado.dias[0].horaInicio} - {turnoSeleccionado.dias[0].horaFin}</div>
                          </div>
                        </div>
                        <div className="cita-field-card">
                          <FontAwesomeIcon icon={faRedo} className="cita-icon" />
                          <div>
                            <div className="cita-label">Periodicidad</div>
                            <div className="cita-value">{periodicidad}</div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="cita-field-card">
                          <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon" />
                          <div>
                            <div className="cita-label">Fecha</div>
                            <input type="date" value={nuevaFecha} onChange={e => setNuevaFecha(e.target.value)} className="cita-input" />
                          </div>
                        </div>
                        <div className="cita-field-card">
                          <FontAwesomeIcon icon={faClock} className="cita-icon" />
                          <div>
                            <div className="cita-label">Hora inicio</div>
                            <input type="time" value={nuevaHoraInicio} onChange={e => setNuevaHoraInicio(e.target.value)} className="cita-input" />
                            <div className="cita-label" style={{ marginTop: 8 }}>Hora fin</div>
                            <input type="time" value={nuevaHoraFin} onChange={e => setNuevaHoraFin(e.target.value)} className="cita-input" />
                          </div>
                        </div>
                        <div className="cita-field-card">
                          <FontAwesomeIcon icon={faRedo} className="cita-icon" />
                          <div>
                            <div className="cita-label">Periodicidad</div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <select value={periodicidad} onChange={e => setPeriodicidad(e.target.value)} className="cita-input">
                                <option value="">Seleccione</option>
                                <option value="Semanal">Semanal</option>
                                <option value="Quincenal">Quincenal</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <button
                    className="btnBlue cita-add-btn"
                    onClick={handleAgregarUnaCita}
                    disabled={citasProgramadas.length >= 4}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: 8 }} />
                    Agregar una cita
                  </button>
                  <div className="citas-futuras-list">
                    <div className="citas-futuras-title">
                      <FontAwesomeIcon icon={faListAlt} className="cita-icon" />
                      <b>Citas futuras:</b> (Maximo 4 citas programadas)
                    </div>
                    {citasProgramadas && citasProgramadas.length > 0 ? (
                      <ul className="citas-futuras-ul">
                        {citasProgramadas.map((cita, idx) => {
                          const fechaMoment = moment(cita.dias[0].dia);
                          const diaSemana = fechaMoment.format('dddd');
                          const fechaFormateada = fechaMoment.format('D [de] MMMM [de] YYYY');
                          return (
                            <li key={cita.idTurno} className="citas-futuras-li">
                              <FontAwesomeIcon icon={faCalendarAlt} className="cita-icon-sm" />
                              <span className="cita-futura-text">{diaSemana} {fechaFormateada} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</span>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div className="citas-futuras-empty">No hay citas futuras programadas.</div>
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {/* HISTORIAL */}
          {tab === 'historial' && (
            <div className="card-section">
              <div className="timeline">
                {citasHistorial.map((cita, i) => {
                  const [anioStr, mesStr, diaStr] = cita.dias[0].dia.split('-');
                  const fecha = new Date(parseInt(anioStr), parseInt(mesStr) - 1, parseInt(diaStr));
                  const diasSemana = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
                  const diaSemana = diasSemana[fecha.getDay()];
                  return (
                    <div className="timeline-event" key={cita.idTurno}>
                      <div className="timeline-dot" />
                      <div className="timeline-content">
                        <div><b>Sesión {i + 1}</b>: {diaSemana} {cita.dias[0].dia} de {cita.dias[0].horaInicio} a {cita.dias[0].horaFin}hrs.</div>
                        <div><b>Estatus:</b> {cita.estado}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* COMENTARIOS */}
          {tab === 'comentarios' && (
            <>
              <div className="card-section comentarios-add-card">
                <fieldset className="comentarios-add-fieldset">
                  <textarea
                    placeholder="Agregar comentario.."
                    value={nuevoComentario}
                    onChange={e => setNuevoComentario(e.target.value)}
                    id="comentario"
                    rows={3}
                    className="comentarios-add-textarea"
                  />
                </fieldset>
                <div className="comentarios-btns-row">
                  <button className="btnGrey" onClick={() => checkComentarioCompleto(1)}>
                    Guardar sólo el comentario
                  </button>
                  <button className="btnGreen" onClick={() => checkComentarioCompleto(2)}>
                    Dar de alta paciente
                  </button>
                </div>
                <button className="btnBlue comentarios-btn-agendar" onClick={() => checkComentarioCompleto(3)}>
                  Guardar comentario | Agendar 4 citas
                </button>
              </div>
              <div className="card-section comentarios-timeline">
                <div className="comentarios-timeline-list">
                  {comentarios && comentarios.length > 0 ? (
                    [...comentarios].sort((a, b) => new Date(b.fecha) - new Date(a.fecha)).map((c, idx) => (
                      <div className="comentario-timeline-item" key={c.idComentario}>
                        <div className="comentario-timeline-dot" />
                        <div className="comentario-timeline-content compact">
                          <div className="comentario-timeline-header">
                            <span className="comentario-timeline-user"><FaUser style={{ marginRight: 6 }} />{c.nombre}</span>
                            <span className="comentario-timeline-date"><FaClock style={{ marginRight: 4 }} />{c.fecha}</span>
                          </div>
                          <div className="comentario-timeline-text">{c.comentario}</div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="comentarios-timeline-empty"><FaComment style={{ marginRight: 8 }} />No hay comentarios aún.</div>
                  )}
                </div>
              </div>
            </>
          )}

          {/* PACIENTES */}
          {tab === 'pacientes' && (
            <>
              {/* Resumen de asistencia */}
              {cupoMaximo && (
                <div style={{ 
                  backgroundColor: '#f8f9fa', 
                  padding: '15px', 
                  borderRadius: '8px', 
                  marginBottom: '20px',
                  textAlign: 'center'
                }}>
                  <h4 style={{ margin: '0 0 10px 0' }}>Resumen de Sesión</h4>
                  <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '10px' }}>
                    <div>
                      <strong>Cupo total:</strong> {cupoMaximo}
                    </div>
                    <div>
                      <strong>Inscritos:</strong> {inscritosCount}
                    </div>
                    <div>
                      <strong>Disponibles:</strong> <span style={{ color: cupoDisponible === 0 ? 'red' : 'green' }}>{cupoDisponible}</span>
                    </div>
                    <div>
                      <strong>Presentes:</strong> <span style={{ color: '#28a745' }}>
                        {pacientes.filter(p => p.estado?.toLowerCase() === 'presente').length}
                      </span>
                    </div>
                    <div>
                      <strong>Ausentes:</strong> <span style={{ color: '#dc3545' }}>
                        {pacientes.filter(p => p.estado?.toLowerCase() === 'ausente').length}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: "20px", flexWrap: 'wrap' }}>
                <button className='btnGreen' onClick={() => { handleOpenDatosPacienteNuevoModal(); }}>Agregar Nuevo</button>
                <button className='btnBlue' onClick={() => setModalSeleccionarPacienteIsOpen(true)}>Agregar de la lista</button>
                <button className='btnGrey' onClick={openImportModal}>Importar desde Excel</button>
              </div>
              <ImportarPacientesTaller
                isOpen={importModalOpen}
                onClose={closeImportModal}
                importStep={importStep}
                setImportStep={setImportStep}
                importData={importData}
                importSelected={importSelected}
                importAllSelected={importAllSelected}
                importErrors={importErrors}
                importFileName={importFileName}
                isUploading={isUploading}
                onFileChange={handleFileChange}
                onToggleAll={toggleImportAll}
                onToggleRow={toggleImportSelected}
                onImportSelected={handleImportSelected}
                onChangeRow={handleImportInputChange}
                onResetFile={handleImportResetFile}
                templateUrl={`${baseURL}/templates/plantilla_importacion_pacientes_taller.csv`}
              />
              {pacientes.map((paciente, i) => {
                if (pacientesLoading) {
                  return null;
                }
                
                const estadoActual = (paciente.estado || 'inscrito').toLowerCase();
                
                // Determinar idTurno - buscar en turnos_talleres por idPaciente
                const idTurnoParticipante = paciente.idTurno || null;
                
                return (
                  <div className="card-section" key={paciente.id}>
                    <div><b>{i + 1}/{pacientes.length}</b></div>
                    <div><b>Nombre:</b> {paciente.nombre}</div>
                    <div><b>Teléfono:</b> {paciente.telefono}</div>
                    <div><b>Edad:</b> {paciente.edad}</div>
                    <div><b>Sexo:</b> {paciente.sexo}</div>
                    <div><b>Escolaridad:</b> {paciente.escolaridad}</div>
                    <div><b>Estado Civil:</b> {paciente.estadoCivil}</div>
                    <div><b>Ocupación:</b> {paciente.ocupacion}</div>
                    <div><b>Servicios Salud:</b> {paciente.servicioSalud}</div>
                    <div><b>Religion:</b> {paciente.religion}</div>
                    <div><b>Municipio:</b> {paciente.municipio}</div>
                    <div><b>Motivo Consulta:</b> {paciente.motivoConsulta}</div>
                    <div><b>Cómo se enteró:</b> {paciente.comoEntero}</div>
                    
                    {/* Control de asistencia */}
                    <div style={{ 
                      marginTop: '15px', 
                      padding: '10px', 
                      backgroundColor: '#f8f9fa', 
                      borderRadius: '5px',
                      border: '1px solid #dee2e6'
                    }}>
                      <div style={{ marginBottom: '8px' }}>
                        <b>Asistencia:</b> 
                        <span style={{ 
                          marginLeft: '10px',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          backgroundColor: estadoActual === 'presente' ? '#d4edda' : 
                                         estadoActual === 'ausente' ? '#f8d7da' : 
                                         estadoActual === 'cancelado' ? '#fff3cd' : '#e2e3e5',
                          color: estadoActual === 'presente' ? '#155724' : 
                                 estadoActual === 'ausente' ? '#721c24' : 
                                 estadoActual === 'cancelado' ? '#856404' : '#383d41',
                          fontWeight: 'bold'
                        }}>
                          {estadoActual === 'asignado' || estadoActual === 'inscrito' ? 'Inscrito' : 
                           estadoActual === 'presente' ? 'Presente' : 
                           estadoActual === 'ausente' ? 'Ausente' : 
                           estadoActual === 'cancelado' ? 'Cancelado' : estadoActual}
                        </span>
                      </div>
                      {idTurnoParticipante && (
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                          <button 
                            className='btnGreen' 
                            style={{ 
                              padding: '6px 12px', 
                              fontSize: '0.9em',
                              opacity: estadoActual === 'presente' ? 0.6 : 1
                            }}
                            onClick={() => actualizarEstadoAsistencia(idTurnoParticipante, 'presente')}
                            disabled={estadoActual === 'presente'}
                          >
                            ✓ Presente
                          </button>
                          <button 
                            className='btnRed' 
                            style={{ 
                              padding: '6px 12px', 
                              fontSize: '0.9em',
                              opacity: estadoActual === 'ausente' ? 0.6 : 1
                            }}
                            onClick={() => actualizarEstadoAsistencia(idTurnoParticipante, 'ausente')}
                            disabled={estadoActual === 'ausente'}
                          >
                            ✗ Ausente
                          </button>
                          <button 
                            className='btnGrey' 
                            style={{ 
                              padding: '6px 12px', 
                              fontSize: '0.9em',
                              opacity: (estadoActual === 'inscrito' || estadoActual === 'asignado') ? 0.6 : 1
                            }}
                            onClick={() => actualizarEstadoAsistencia(idTurnoParticipante, 'inscrito')}
                            disabled={estadoActual === 'inscrito' || estadoActual === 'asignado'}
                          >
                            ↺ Restablecer
                          </button>
                        </div>
                      )}
                    </div>

                    <div style={{ "display": "flex", marginTop: "20px" }}>
                      <button className='btnBlue' style={{ margin: "5px", width: "170px" }} onClick={() => { handleOpenDatosPacienteExistenteModal(paciente.id); }}>Editar</button>
                      <button className='btnRed' style={{ margin: "5px", width: "170px" }} onClick={() => { desinscribirPaciente(paciente.id, paciente.nombre); }}>Desinscribir</button>
                    </div>
                  </div>
                );
              })}

              {pacientesLoading && (
                <div className="card-section skeleton-card">Cargando pacientes…</div>
              )}


            </>
          )}
        </div>
      </Modal>
      <Modal
        isOpen={modalDatosPacienteIsOpen}
        onRequestClose={handleCloseDatosPacienteModal}
        ariaHideApp={false}
        className="modal-datos-paciente"
        overlayClassName="overlay-admin"
      >
        <div className='header'>
          <h4>Datos del Paciente</h4>
        </div>
        <div className='flexGrap'>
          <fieldset>
            <legend>Nombre: (*)</legend>
            <input
              type="text"
              value={nombrePaciente}
              onChange={(e) => setNombrePaciente(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Teléfono: (*)</legend>
            <input
              type="text"
              value={telefonoPaciente}
              onChange={(e) => setTelefonoPaciente(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Edad: (*)</legend>
            <input
              type="number"
              value={edadPaciente}
              onChange={(e) => setEdadPaciente(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Sexo: (*)</legend>
            <select
              value={sexo}
              onChange={(e) => {
                setSexo(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoSexo.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Escolaridad:</legend>
            <select
              value={escolaridad}
              onChange={(e) => {
                setEscolaridad(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoEscolaridad.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Estado Civil:</legend>
            <select
              value={estadoCivil}
              onChange={(e) => {
                setEstadoCivil(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoEstadoCivil.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Ocupación:</legend>
            <input
              type="text"
              value={ocupacion}
              onChange={(e) => setOcupacion(e.target.value)}
            />
          </fieldset>

          <fieldset>
            <legend>Acceso a servicios de salud:</legend>
            <select
              value={servicioSalud}
              onChange={(e) => {
                setServicioSalud(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoServiciosSalud.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Religión:</legend>
            <select
              value={religion}
              onChange={(e) => {
                setReligion(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoReligiones.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Municipio:</legend>
            <select
              value={municipio}
              onChange={(e) => {
                setMunicipio(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoMunicipios.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>Motivo de Consulta:</legend>
            <select
              value={motivoConsulta}
              onChange={(e) => {
                setMotivoConsulta(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoMotivosConsulta.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

          <fieldset>
            <legend>¿Cómo se enteró de CESECO?</legend>
            <select
              value={comoEntero}
              onChange={(e) => {
                setComoEntero(e.target.value);
              }}
            >
              <option value="">Seleccione una opción</option>
              {catalogoComoEntero.map(item => (
                <option value={`${item.id}`}>{item.nombre}</option>
              ))}

            </select>
          </fieldset>

        </div>

        <div className='footer'>
          <button
            onClick={guardarPaciente}
            className="btnPost"
          >
            Guardar
          </button>



        </div>
      </Modal>

      {/* Modal para seleccionar paciente existente */}
      <Modal
        isOpen={modalSeleccionarPacienteIsOpen}
        onRequestClose={() => setModalSeleccionarPacienteIsOpen(false)}
        className="modal-datos-paciente"
        overlayClassName="overlay-admin"
      >
        <div className='header'>
          <h4>Seleccionar Paciente</h4>
        </div>
        <div className='flexGrap' style={{ padding: '20px' }}>
          <div style={{ width: '100%', marginBottom: '16px' }}>
            <label>Buscar por nombre o telefono:</label>
            <input
              type="text"
              className="form-control"
              value={buscadorPaciente}
              onChange={(e) => setBuscadorPaciente(e.target.value)}
              placeholder="Escribe nombre o telefono"
              style={{ width: '100%', padding: '8px', marginTop: '5px' }}
            />
          </div>
          <div style={{ width: '100%', marginBottom: '16px' }}>
            <label>Selecciona un paciente:</label>
            <div
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: 8,
                maxHeight: 280,
                overflowY: 'auto',
                padding: 8,
                background: '#fafafa'
              }}
            >
              {allPacientes
                .filter((paciente) => {
                  const query = buscadorPaciente.trim().toLowerCase();
                  if (!query) return true;
                  const nombre = (paciente.nombre || '').toLowerCase();
                  const telefono = (paciente.telefono || '').toString().toLowerCase();
                  return nombre.includes(query) || telefono.includes(query);
                })
                .slice(0, 50)
                .map((paciente) => (
                  <button
                    key={paciente.id}
                    type="button"
                    onClick={() => setPacienteSeleccionado(paciente.id)}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      padding: '10px 12px',
                      marginBottom: 6,
                      borderRadius: 6,
                      border: pacienteSeleccionado == paciente.id ? '1px solid #1976d2' : '1px solid #e0e0e0',
                      background: pacienteSeleccionado == paciente.id ? '#e3f2fd' : '#fff',
                      cursor: 'pointer'
                    }}
                  >
                    <div style={{ fontWeight: 600 }}>{paciente.nombre}</div>
                    <div style={{ fontSize: 13, color: '#666' }}>
                      Tel: {obtenerTelefonoMasked(paciente.telefono)}
                    </div>
                  </button>
                ))}
              {allPacientes.length === 0 && (
                <div style={{ color: '#777', padding: '8px 4px' }}>No hay pacientes registrados.</div>
              )}
              {allPacientes.length > 0 &&
                allPacientes.filter((paciente) => {
                  const query = buscadorPaciente.trim().toLowerCase();
                  if (!query) return true;
                  const nombre = (paciente.nombre || '').toLowerCase();
                  const telefono = (paciente.telefono || '').toString().toLowerCase();
                  return nombre.includes(query) || telefono.includes(query);
                }).length === 0 && (
                  <div style={{ color: '#777', padding: '8px 4px' }}>Sin resultados.</div>
                )}
            </div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 6 }}>
              Mostrando hasta 50 resultados. Tel mostrado con los ultimos 4 digitos.
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: '100%' }}>
            <button className='btnRed' onClick={() => setModalSeleccionarPacienteIsOpen(false)}>Cancelar</button>
            <button 
              className='btnGreen' 
              onClick={() => {
                if (pacienteSeleccionado) {
                  const paciente = allPacientes.find(p => p.id == pacienteSeleccionado);
                  if (paciente) {
                    // Verificar si el paciente ya está inscrito en este taller
                    const yaInscrito = pacientes.some(p => p.id === paciente.id);
                    if (yaInscrito) {
                      avisoFalta('Este paciente ya está inscrito en el taller');
                      return;
                    }
                    inscribirPacienteExistente(paciente);
                  }
                } else {
                  avisoFalta('Por favor selecciona un paciente');
                }
              }}
            >
              Guardar
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TurnoModal;
